import { useAuth } from '@/store/useAppStore';
import { NotificationBell } from '@/features/notifications';

/**
 * Actions mobile en haut à droite
 * Notification + Déconnexion - visible uniquement sur mobile
 */
export function MobileTopActions() {
  const { signOut } = useAuth();

  return (
    <div className="md:hidden fixed top-4 right-4 z-header flex items-center gap-2">
      {/* Notification */}
      <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-white/80 backdrop-blur-md shadow-lg border border-slate-200/50">
        <NotificationBell />
      </div>

      {/* Déconnexion */}
      <button
        onClick={signOut}
        className="flex items-center justify-center w-11 h-11 rounded-xl bg-white/80 backdrop-blur-md shadow-lg border border-slate-200/50 text-slate-600 hover:bg-red-50 hover:text-red-500 hover:border-red-200 transition-all active:scale-95"
        aria-label="Déconnexion"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
      </button>
    </div>
  );
}
